<template>
<layout-content>
  <template #toolbar>
    <label style="font-size:14px;">类型:</label>
    <label-switch
      v-model="pageURL"
      :options="pageInfos"
      style="height:2rem;line-height:1.5rem;"
      @change="onPageURLChange"
    />
  </template>

  <template #body>
    <data-wrapper>
      <div class="data-display-wrapper">
        <img-player v-model="imgSrc" :img-infos="reverseImgInfos" />

        <data-time-switch v-model="imgSrc" :options="imgInfos" />
      </div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseStore from '../../../../../components/BaseStore'
import crawler from '../../../../../utils/crawler'
import LayoutContent from '../../../../../components/Layout/Content'
import LabelSwitch from '../../../../../components/LabelSwitch/index'
import DataWrapper from '../../../../../components/Data/DataWrapper'
import DataTimeSwitch from '../../../../../components/DataTimeSwitch'
import ImgPlayer from '../../../../../components/ImgPlayer'

export default {
  name: 'RadarChart',
  routeInfo: {
    label: '雷达图分析',
    icon: 'fa fa-users'
  },
  extends: BaseStore,
  components: {ImgPlayer, DataTimeSwitch, DataWrapper, LabelSwitch, LayoutContent},
  data: () => ({
    pageInfos: Object.freeze([]),
    imgInfos: Object.freeze([]),
    pageURL: '/publish/radar/chinaall.html',
    imgSrc: null
  }),
  computed: {
    reverseImgInfos () {
      return [...this.imgInfos].reverse()
    }
  },
  methods: {
    getInfo () {
      this.changeLoadStatus(true)

      crawler(this.$api.Crawler.getWeather, this.pageURL, {
        pageEles: '.p-nav.nav1 a',
        dataTimeEles: '#myTabContent .time'
      }).then(config => {
        this.setPageInfos(config.pageEles)
        this.setImgInfos(config.dataTimeEles)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setPageInfos (pageEles) {
      this.pageInfos = Object.freeze(pageEles.map(pageEle => ({
        value: pageEle.getAttribute('href'),
        label: pageEle.textContent
      })))
    },
    setImgInfos (dataTimeEles) {
      const imgInfos = this.imgInfos = Object.freeze(dataTimeEles.map(({dataset}) => ({
        value: dataset.img,
        label: dataset.time
      })))

      imgInfos.forEach(imgInfos => {
        const img = new Image()
        img.src = imgInfos.value
      })

      this.imgSrc = imgInfos.length > 0 ? imgInfos[0].value : null
    },
    onPageURLChange () {
      this.getInfo()
    }
  },
  created () {
    this.getInfo()
  }
}
</script>

<style lang="scss" scoped>
.data-display-wrapper {
  display: grid;
  grid-template-columns: auto max-content;
  grid-column-gap: 1rem;
  width: 100%;
  height: 100%;

  > * {
    min: {
      width: 0;
      height: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/03Pollution/01Meteorological/05RadarChart/index.vue